import { render, staticRenderFns } from "./entryRegister.vue?vue&type=template&id=2e205468&"
import script from "./entryRegister.vue?vue&type=script&lang=js&"
export * from "./entryRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports